/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixels per inch — how many pixels fit into one inch of the screen. It describes pixel density and therefore sharpness.`)
};

const es_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Píxeles por pulgada — cuántos píxeles caben en una pulgada de la pantalla. Describe la densidad de píxeles y, por tanto, la nitidez.`)
};

const de_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixel pro Zoll — wie viele Pixel auf einen Zoll des Bildschirms passen. Er beschreibt die Pixeldichte und damit die Schärfe.`)
};

const nl_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixels per inch — hoeveel pixels in één inch van het scherm passen. Het beschrijft de pixeldichtheid en dus de scherpte.`)
};

const fr_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixels par pouce — combien de pixels tiennent dans un pouce de l'écran. Cela décrit la densité de pixels et donc la netteté.`)
};

const it_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixel per pollice — quanti pixel entrano in un pollice dello schermo. Descrive la densità di pixel e quindi la nitidezza.`)
};

const pt_br2_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixels por polegada — quantos pixels cabem em uma polegada da tela. Descreve a densidade de pixels e, portanto, a nitidez.`)
};

const pt_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixels por polegada — quantos pixels cabem numa polegada do ecrã. Descreve a densidade de pixels e, por isso, a nitidez.`)
};

const ja_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1インチあたりのピクセル数のことです — 画面の1インチにいくつのピクセルが収まるかを表します。ピクセル密度、つまり鮮明さを示します。`)
};

const zh_ppi_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每英寸像素数——一英寸屏幕内容纳的像素数量。它描述的是像素密度，因而也决定了清晰度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_a1", locale)
	if (locale === "en") return en_ppi_faq_a1(inputs)
	if (locale === "es") return es_ppi_faq_a1(inputs)
	if (locale === "de") return de_ppi_faq_a1(inputs)
	if (locale === "nl") return nl_ppi_faq_a1(inputs)
	if (locale === "fr") return fr_ppi_faq_a1(inputs)
	if (locale === "it") return it_ppi_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_a1(inputs)
	if (locale === "pt") return pt_ppi_faq_a1(inputs)
	if (locale === "ja") return ja_ppi_faq_a1(inputs)
	return zh_ppi_faq_a1(inputs)
};